// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"251":"e8c588c8","318":"ad82aea4","348":"7726de65","488":"26aac4c8","626":"f27e1f7a","717":"8b5a5b0d"}[chunkId] + ".chunk.js";
};